const [ACTIVATE_DEBUG, DEACTIVATE_DEBUG, DEBUG_LOG] = ["activate", "deactivate", "log"];

export default {
	namespaced: true,
	state: {
		active: false,
		history: [],
	},
	actions: {
		activate({ commit }) {
			commit(ACTIVATE_DEBUG);
		},
		deactivate({ commit }) {
			commit(DEACTIVATE_DEBUG);
		},
		log({ commit, state }, data) {
			if (state.active) {
				// eslint-disable-next-line no-console
				console.table(data);
				commit(DEBUG_LOG, data);
			}
		},
	},
	mutations: {
		[ACTIVATE_DEBUG](state) {
			state.active = true;
		},
		[DEACTIVATE_DEBUG](state) {
			state.active = false;
		},
		[DEBUG_LOG](state, data) {
			state.history.push(data);
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/global/debug.store.js